/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Bislama2Inputs */

const en__field__enum_nativelanguage_bislama2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Bislama2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bislama`)
};

const de__field__enum_nativelanguage_bislama2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Bislama2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bislama`)
};

/**
* | output |
* | --- |
* | "Bislama" |
*
* @param {_Field__Enum_Nativelanguage_Bislama2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_bislama2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Bislama2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Bislama2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_bislama2(inputs)
	return de__field__enum_nativelanguage_bislama2(inputs)
});
export { _field__enum_nativelanguage_bislama2 as "_field__enum_nativeLanguage_Bislama" }